<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Online inquiry view</span>
        </div>
        <!-- <div class="rfp">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">新增</el-button>
        </div> -->
        <div class="rfp">
          <div style="display:inline-block" v-fileuploadk3 @upload-change="uploadSuccess">
            <el-button type="primary">Upload price Excel</el-button>
          </div>
          <el-button type="primary" @click="exportPopShow=true;selectUser=''">Export</el-button>
        </div>
        <!-- <div class="mc-search-box hf rfp">
            <div class="ftp">
              <el-input size="small" class="mc-search-wrap" placeholder="Please enter the content" v-model="search.value">
                <el-select size="small" v-model="search.key" slot="prepend" placeholder="请选择">
                  <el-option label="券码" value="VNum"></el-option>
                  <el-option label="发放人姓名" value="VCustomerName"></el-option>
                  <el-option label="发放人手机号" value="VCustomerMobile"></el-option>
                  <el-option label="发放人车牌号" value="VCustomerCarNum"></el-option>
                </el-select>
                <el-button slot="append" icon="search" @click="handleSearch"></el-button>
              </el-input>
            </div>
            <el-button size="small" class="search-btn ftp" @click="handleResetSearch">重置</el-button>
          </div> -->
      </div>
      <div class="page-table table-wrap">
        <el-table :data="table.data" v-loading="table.isLoading" element-loading-text="Loading" style="width: 100%">
          <el-table-column label="Product code" prop="Model" min-width="120"></el-table-column>
          <el-table-column label="W" prop="Width" min-width="70"></el-table-column>
          <el-table-column label="L" prop="Length" min-width="70"></el-table-column>
          <el-table-column label="Quantity" prop="Num" min-width="90"></el-table-column>
          <el-table-column label="Delivery date" prop="SupplyDay" min-width="110"></el-table-column>
          <el-table-column label="Unit price    (tax free)" width="110">
            <template slot-scope="scope">
              {{scope.row.PriceNoTax | priceHandle}}
            </template>
          </el-table-column>
          <el-table-column label="Unit price    (tax included)" width="110">
            <template slot-scope="scope">
              {{scope.row.Price | priceHandle}}
            </template>
          </el-table-column>
          <el-table-column label="Total           (tax free)" width="100">
            <template slot-scope="scope">
              {{scope.row.AllPriceNoTax | priceHandle}}
            </template>
          </el-table-column>
          <el-table-column label="Total             (tax included)" width="120">
            <template slot-scope="scope">
              {{scope.row.AllPrice | priceHandle}}
            </template>
          </el-table-column>
          <el-table-column label="Submit account" prop="Account" min-width="130"></el-table-column>
          <el-table-column label="Submit date" min-width="110">
            <template slot-scope="scope">
              {{scope.row.CreateTime | dateFormat}}
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="small" @click="showUpdatePop(scope.$index, scope.row)">Edit</el-button>
              <el-button size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="page-wrap">
        <el-pagination @current-change="handleTableCurrentChange" :current-page="table.currentPage" :page-size="table.pageSize" layout="total, prev, pager, next" :total="table.pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹出层 -->
    <!-- <el-dialog title="Details" :visible.sync="page.popShow" size="tine">
      <ProductMemberTypeForm @addSuccess="handleAdd" @updateSuccess="handleUpdate" ref="popForm"></ProductMemberTypeForm>
    </el-dialog> -->
    <!-- 导出弹出层 -->
    <el-dialog title="Export" size="tine" v-model="exportPopShow">
      <ExportForm url="/Ajax/ProductListToExcelInAdmin" :extraData="{Account:selectUser,lang:1}" @FormClose="exportPopShow=false">
        <el-form-item label="Account">
          <el-select v-model="selectUser" filterable clearable placeholder="Please select user account">
            <el-option v-for="(item, idx) in userData" :key="idx" :label="item.Account" :value="item.Account"></el-option>
          </el-select>
        </el-form-item>
      </ExportForm>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
// import ProductMemberTypeForm from '@/components/product/ProductMemberTypeForm'
import ExportForm from '@/components/product/ExportForm'

// 表格相关操作
let table = {
  methods: {
    getTableData: tools.commonTableDateFetch({
      url: '/Ajax/GetProductListInAdmin',
      success(response) {
        let result = response.data
        let shuilv = this.configData ? this.configData.PrTax : 0.16
        result.forEach(item => {
          item.AllPrice = item.Price * item.Num
          item.PriceNoTax = parseFloat((item.Price / (1 + shuilv)).toFixed(2))
          item.AllPriceNoTax = item.PriceNoTax * item.Num
        })
        this.table.data = result
      }
    }),
    refreshTableData() {
      this.getTableData(this.table.currentPage)
    }
  }
}

// 请求相关操作
let page = {
  methods: {
    // 获得所有用户
    getAllUserDataAjax() {
      tools.commonAjax.call(this, true, '/Ajax/GetCustomListInAdmin', {
        All: 1
      }).then(res => {
        let result = res.data
        this.userData = result
      })
    },
    // 获得配置项
    getConfigDataAjax() {
      return tools.commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon').then(res => {
        let result = res.data
        this.configData = result
      })
    },
    // 删除操作
    delDataAjax(CtCode) {
      // tools.commonAjax.call(this, true, '/Ajax/DelCustomTypeInAdmin', {
      //   CtCode
      // }).then(() => {
      //   this.$message.success('Deleted successfully!')
      //   // 重新获取列表数据
      //   this.refreshTableData()
      // })
    }
  }
}

export default {
  name: 'EnquiryOnlineSubmitManagement',
  mixins: [table, page, mixin.filter],
  components: {
    // ProductMemberTypeForm
    ExportForm
  },
  created() {
    // 获得配置项
    this.getConfigDataAjax().then(() => {
      this.getTableData()
    })
    // 获得所有用户
    this.getAllUserDataAjax()
  },
  data() {
    return {
      search: {
        key: '',
        value: ''
      },
      userData: [],
      configData: null,
      selectUser: '',
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {}, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      },
      exportPopShow: false
    }
  },
  filters: {
    priceHandle(data) {
      data = parseFloat(data)
      if (!isNaN(data)) {
        return parseFloat(data.toFixed(2))
      } else {
        return 0
      }
    }
  },
  methods: {
    uploadSuccess() {
      this.$message.success('Uploaded successfully!')
    },
    // 搜索事件
    handleSearch() {
      if (this.search.value) {
        this.table.ajaxData = {}
        this.table.ajaxData[this.search.key] = this.search.value
        this.refreshTableData()
      } else {
        this.$message.error('Please enter the search content')
      }
    },
    // 重置搜索
    handleResetSearch() {
      this.table.ajaxData = {}
      this.search.value = ''
      this.refreshTableData()
    },
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getTableData(val)
    },
    // 显示新增弹出层
    showAddPop() {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.resetValue()
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function () {
        this.$refs.popForm.setValue(item)
      })
    },
    // 添加操作
    handleAdd() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This operation will permanently delete the record, whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.CtCode)
      })
    }
  }
}
</script>

<style lang="scss">
.page-table {
  th > .cell {
    word-break: normal !important;
    white-space: pre-wrap !important;
  }
}
</style>



// WEBPACK FOOTER //
// EnquiryOnlineSubmitManagement.vue?6d1e4472